var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import { useOutside, useToggle } from '@hn-front/utils';
import { styled } from 'styled-components';
import { AscIcon, DescIcon } from '../../../images/icons';
import { Direction } from '../../../types';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-hczjr3" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 50;\n  position: relative;\n  height: 24px;\n"], ["\n  z-index: 50;\n  position: relative;\n  height: 24px;\n"])));
var MenuContainer = styled.div.withConfig({ displayName: "MenuContainer", componentId: "sc-izf7p2" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  position: absolute;\n  background-color: #ffffff;\n  padding-bottom: 16px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  position: absolute;\n  background-color: #ffffff;\n  padding-bottom: 16px;\n"])));
var ItemContainer = styled.a.attrs(function (_a) {
    var $active = _a.$active;
    if (!$active)
        return undefined;
    return {
        'data-active': '',
    };
}).withConfig({ displayName: "ItemContainer", componentId: "sc-jiivqs" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 24px;\n  align-items: center;\n  color: ", ";\n\n  & path {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n\n    & path {\n      fill: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    margin-bottom: 30px;\n  }\n"], ["\n  display: flex;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 24px;\n  align-items: center;\n  color: ", ";\n\n  & path {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n\n    & path {\n      fill: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    margin-bottom: 30px;\n  }\n"])), function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return $active ? theme.colors.primaryHover : theme.colors.primary;
}, function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return $active ? theme.colors.primaryHover : theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryHover;
});
var IconContainer = styled.div.withConfig({ displayName: "IconContainer", componentId: "sc-19q1a0m" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 20px;\n  margin-right: 8px;\n  padding-top: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 20px;\n  margin-right: 8px;\n  padding-top: 4px;\n"])));
var TextContainer = styled.div.withConfig({ displayName: "TextContainer", componentId: "sc-1903khs" })(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var ScAscIcon = styled(AscIcon).withConfig({ displayName: "ScAscIcon", componentId: "sc-1e2lgpq" })(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var ScDescIcon = styled(DescIcon).withConfig({ displayName: "ScDescIcon", componentId: "sc-1d0ljub" })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var MenuItems = function (_a) {
    var items = _a.items, onClick = _a.onClick, isMenuOpen = _a.isMenuOpen, activeItem = _a.activeItem;
    var _items = Array.isArray(items) ? items : [items];
    return (_jsx(_Fragment, { children: _items.map(function (item) {
            var text = item.text, direction = item.direction, sortType = item.sortType;
            return (_jsxs(ItemContainer, __assign({ role: 'menuitem', onClick: function () {
                    if (onClick)
                        onClick(item);
                }, "$active": sortType === activeItem.sortType &&
                    direction === activeItem.direction &&
                    isMenuOpen }, { children: [_jsx(IconContainer, { children: direction === Direction.Asc ? _jsx(ScAscIcon, {}, void 0) : _jsx(ScDescIcon, {}, void 0) }, void 0), _jsx(TextContainer, { children: text }, void 0)] }), text + "_" + direction));
        }) }, void 0));
};
var SortMenu = function (_a) {
    var items = _a.items, onSort = _a.onSort, rest = __rest(_a, ["items", "onSort"]);
    var _b = useState(items[0]), activeSortItem = _b[0], setActiveSortItem = _b[1];
    var _c = useToggle(false), isSortMenuOpen = _c.isToggled, toggleSortMenu = _c.toggle;
    var refSortMenu = useRef(null);
    useOutside(refSortMenu, function () { return isSortMenuOpen && toggleSortMenu(); });
    var ActiveItem = function () { return (_jsx(MenuItems, { items: activeSortItem, onClick: toggleSortMenu, isMenuOpen: isSortMenuOpen, activeItem: activeSortItem }, void 0)); };
    var onSortMemoized = useCallback(function (item) {
        var sortType = item.sortType, direction = item.direction;
        onSort(sortType, direction);
        setActiveSortItem(item);
        toggleSortMenu();
    }, []);
    var Items = function () { return (_jsx(MenuItems, { items: items.filter(function (_a) {
            var direction = _a.direction, sortType = _a.sortType;
            return sortType !== activeSortItem.sortType ||
                direction !== activeSortItem.direction;
        }), onClick: onSortMemoized, activeItem: activeSortItem }, void 0)); };
    return (_jsx(Container, __assign({ "data-testid": 'sort-menu', ref: refSortMenu }, rest, { children: _jsxs(MenuContainer, __assign({}, rest, { role: 'menu' }, { children: [_jsx(ActiveItem, {}, void 0), isSortMenuOpen && _jsx(Items, {}, void 0)] }), void 0) }), void 0));
};
export { SortMenu };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
